import * as React from 'react';
import { SentimentData } from '../../../interfaces/storyAnalysis.interface';
import { asPercent } from './helpers/asPercent';

const SentimentAnalysis: React.FC<{ data: SentimentData }> = ({ data }) => {
  // Normalize both old (OpenAI) and new (local LLM) API shapes
  const label = data.label ?? data.primary;
  const score = data.score ?? data.confidence;

  if (!label || score === null || score === undefined) return null;

  return (
    <div>
      <h3>Sentiment Scores</h3>
      <div className="Stack">
        <div>Label: {label}</div>
        <div>Score: {asPercent(score)}</div>
      </div>
    </div>
  );
};

export default SentimentAnalysis;
